import { Injectable } from '@angular/core';
import { DashboardHttpService } from './http/dashboard-http.service';
import { Observable, map } from 'rxjs';
import { PracticeMetrics, IPracticeMetrics } from 'src/app/models/dashboard/metric.model';
import { IMco, IResultMcoModel, Mco, ResultMcoModel } from 'src/app/models/dashboard/mco.model';
import {
  IResultKpiModel,
  IResultQualityScoreCard,
  ResultKpiModel,
  ResultQualityScoreCard
} from "../../models/dashboard/kpi.model";
import {
  IResultProvider,
  ResultProvider,
} from "../../models/accounts/provider.model";
import {IResultPatient, ResultPatient, SortOption} from "../../models/dashboard/patient.model";
import {IPracticeMcoProductResult, PracticeMcoProductResult} from "../../models/dashboard/practice-mco-product.model";


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private dashboardHttpService: DashboardHttpService) { }

  getKpi(practiceId:string):Observable<ResultKpiModel>{
    return this.dashboardHttpService
      .getKpi(practiceId)
      .pipe(
        map((metricsModel: IResultKpiModel) => ResultKpiModel.fromObject(metricsModel))
      );
  }
  getQualityFilters(practiceId: string, type: 'mco' | 'product' | 'line_of_business' | 'measure'): Observable<any> {
    return this.dashboardHttpService
      .getQualityFilters(practiceId, type)
      .pipe(
        map((filters: any) => filters)
      );
  }

  getQualityScore(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0):Observable<ResultQualityScoreCard>{
    return this.dashboardHttpService
      .getQualityScore(wheres, limit, offset)
      .pipe(
        map((metricsModel: IResultQualityScoreCard) => ResultQualityScoreCard.fromObject(metricsModel))
      );
  }
  /*
   getQualityScore(practiceId:string):Observable<IResultQualityScoreCard>{
    return this.http.get<IResultQualityScoreCard>(`${environment.apiUrl}/catalog/app_quality_score/?practice_id=${practiceId}`);

  }
  * */
  dashboardPractice(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<PracticeMetrics> {
    return this.dashboardHttpService
      .dashboardPractice(wheres, limit, offset)
      .pipe(
        map((metricsModel: IPracticeMetrics) => new PracticeMetrics(metricsModel))
      );
  }
  dashboardPracticeMCO(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<ResultMcoModel> {
    return this.dashboardHttpService
      .dashboardPracticeMCO(wheres, limit, offset)
      .pipe(
        map((mcoModel: IResultMcoModel) => new ResultMcoModel(mcoModel))
      );
  }

  dashboardfilterMCO(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<ResultMcoModel> {
    return this.dashboardHttpService
      .dashboardfilterMCO(wheres, limit, offset)
      .pipe(
        map((mcoModel: IResultMcoModel) => new ResultMcoModel(mcoModel))
      );
  }
  dashboardMcoList(
    wheres: Record<string, string>,
    limit: number = 100,
    offset: number = 0
  ): Observable<ResultMcoModel> {
    return this.dashboardHttpService
      .dashboardMcoList(wheres, limit, offset)
      .pipe(
        map((items: IMco[] | null | undefined) => {
          const results = items ?? [];
          return new ResultMcoModel({
            count: results.length,
            next: '',
            previous: '',
            results
          });
        })
      );
  }


  dashboardfilterProvider(wheres: { [key: string]: string },limit: number = 100, offset: number = 0): Observable<ResultProvider> {
    return this.dashboardHttpService
      .dashboardfilterProvider(wheres, limit, offset)
      .pipe(
        map((mcoModel: IResultProvider) => new ResultProvider(mcoModel))
      );
  }

  dashboardfilterAccountProvider(wheres: { [key: string]: string },limit: number = 100, offset: number = 0): Observable<ResultProvider> {
    return this.dashboardHttpService
      .dashboardfilterAccountProvider(wheres, limit, offset)
      .pipe(
        map((mcoModel: IResultProvider) => new ResultProvider(mcoModel))
      );
  }
  dashboardPatient(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<ResultPatient> {
    return this.dashboardHttpService
      .dashboardPatient(wheres, limit, offset)
      .pipe(
        map((ent: IResultPatient) => new ResultPatient(ent))
      );
  }

  getPracticeMcoProduct(practiceId:string): Observable<PracticeMcoProductResult> {
    return this.dashboardHttpService
      .getPracticeMcoProduct(practiceId)
      .pipe(
        map((result: IPracticeMcoProductResult) => new PracticeMcoProductResult(result))
      );
  }

  getMeasures(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<any> {
    return this.dashboardHttpService
      .getMeasures(wheres, limit, offset)
      .pipe(
        map((result: any) => result)
      );
  }
}
